import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Form, { GroupItem, SimpleItem, Label } from 'devextreme-react/form';
import Button from 'devextreme-react/button';
import { useScreenSize } from '../../../utils/media-query';
import { useAuth } from '../../../contexts/auth';

function OvertimeApproval() {
    const params = useParams();
    const navigate = useNavigate();
    useAuth();
    const screenSize = useScreenSize();
    const formRef = useRef();

    const [formData, setFormData] = useState({
        requesterName: '',
        employeeName: '',
        departmentName: '',
        startDate: new Date(),
        startTime: new Date(),
        endDate: new Date(),
        endTime: new Date(),
        locationName: '',
        description: ''
    });
    const [readOnly] = useState(true);

    // useEffect(() => {
    //     if (params.id) {
    //         fetch(`http://localhost:3000/overtimeData/${params.id}`)
    //             .then(response => {
    //                 if (!response.ok) {
    //                     throw new Error('Veri bulunamadı');
    //                 }
    //                 return response.json();
    //             })
    //             .then(data => {
    //                 setFormData({
    //                     ...data,
    //                     startDate: new Date(data.startDate),
    //                     endDate: new Date(data.endDate)
    //                 });
    //             })
    //             .catch(error => {
    //                 console.error('Hata:', error);
    //                 navigate('/overtime');
    //             });
    //     }
    // }, [params.id, navigate]);

    // const handleApprove = useCallback(() => {
    //     fetch(`http://localhost:3000/overtimeData/${params.id}`, {
    //         method: 'PATCH',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({ status: 'APPROVED' })
    //     })
    //         .then(() => {
    //             navigate('/overtime');
    //         });
    // }, [navigate, params.id]);

    // const handleReject = useCallback(() => {
    //     fetch(`http://localhost:3000/overtimeData/${params.id}`, {
    //         method: 'PATCH',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({ status: 'REJECTED' })
    //     })
    //         .then(() => {
    //             navigate('/overtime');
    //         });
    // }, [navigate, params.id]);

    const dateEditorOptions = {
        displayFormat: 'dd.MM.yyyy',
        type: 'date'
    };

    const timeEditorOptions = {
        type: 'time',
        displayFormat: 'HH:mm'
    };

    return (
        <div className="content-block">
            <div className="dx-card responsive-paddings">
                <Form
                    formData={formData}
                    readOnly={readOnly}
                    labelLocation={screenSize.isXSmall ? 'top' : 'left'}
                    width={500}
                    ref={formRef}
                >
                    <GroupItem caption="Mesai Bilgileri">
                        <SimpleItem dataField="requesterName">
                            <Label text="Talep Eden" />
                        </SimpleItem>
                        <SimpleItem dataField="employeeName">
                            <Label text="Fazla Mesai Yapan" />
                        </SimpleItem>
                        <SimpleItem dataField="departmentName">
                            <Label text="Departman" />
                        </SimpleItem>
                        <GroupItem colCount={2}>
                            <SimpleItem dataField="startDate" editorType="dxDateBox" editorOptions={dateEditorOptions}>
                                <Label text="Başlama Tarihi" />
                            </SimpleItem>
                            <SimpleItem dataField="startTime" editorType="dxDateBox" editorOptions={timeEditorOptions}>
                                <Label text="Saati" />
                            </SimpleItem>
                        </GroupItem>
                        <GroupItem colCount={2}>
                            <SimpleItem dataField="endDate" editorType="dxDateBox" editorOptions={dateEditorOptions}>
                                <Label text="Bitiş Tarihi" />
                            </SimpleItem>
                            <SimpleItem dataField="endTime" editorType="dxDateBox" editorOptions={timeEditorOptions}>
                                <Label text="Saati" />
                            </SimpleItem>
                        </GroupItem>
                        <SimpleItem dataField="locationName">
                            <Label text="F. Mesai Konumu" />
                        </SimpleItem>
                        <SimpleItem dataField="description" editorType="dxTextArea" editorOptions={{ height: 60 }}>
                            <Label text="Mesai Gerekçesi" />
                        </SimpleItem>
                    </GroupItem>
                </Form>
                <div style={{ display: 'flex', justifyContent: 'left', gap: '20px', marginTop: '20px' }}>
                    {
                        // <>
                        //     <Button text="Onayla" type="success" stylingMode="contained" onClick={handleApprove} width={120} height={35} />
                        //     <Button text="Reddet" type="danger" stylingMode="contained" onClick={handleReject} width={120} height={35} />
                        //     <Button text="İptal" stylingMode="outlined" onClick={() => navigate('/overtime')} width={120} height={35} />
                        // </>
                    }

                </div>
            </div>
        </div>
    );
}

export default OvertimeApproval;